import { ActionTree, ActionContext } from 'vuex';
import { State } from '@/stores/user/state';
import { UserApi } from '@/api/user-api';
import { CustomerApi } from '@/api/customer-api';
import { Customer } from '@/models/customer';
import { loadCustomerIdFromSessionStorage, loadSiteIdFromSessionStorage } from '@/current-customer-site';

const userApi = new UserApi();
const customerApi = new CustomerApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchMeAsync = async (context: ActionContext<State, any>) => {
        const result = await userApi.fetchMeAsync();
        if (result) {
            context.commit('setUser', result);
            const customerResult = await customerApi.fetchAsync();
            context.commit('customer/setCustomers', customerResult.customers, { root: true });

            // Note(Seb): Set the current customer/site if they are not already set up
            const currentCustomer = context.getters['currentCustomer'] as Customer | null;

            if (currentCustomer === null && customerResult.customers.length > 0) {
                // Note(Seb): Check session storage for cached customerId and siteId
                const cachedCustomerId = loadCustomerIdFromSessionStorage();
                const cachedSiteId = loadSiteIdFromSessionStorage();

                const customer = customerResult.customers.find((c) => c.id === cachedCustomerId) || customerResult.customers[0];
                context.commit('setCurrentCustomer', customer);

                if (customer.sites.length > 0) {
                    const site = customer.sites.find((s) => s.id === cachedSiteId) || customer.sites[0];
                    context.commit('setCurrentSite', site);
                }
            }
        }
    }
}
